import React, { useState, useEffect } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import DataTable from "Common/DataTable/DataTable";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import { generateDisplayFields } from "utils/fieldMapper";
import { FilterStatus } from "utils/FilterStatus";
import { getRoleAccessUsersWithPagination } from "adminApi/RoleAssignApi/RoleAssign";
import fields from "./json/RoleAssignFields.json";

const RoleAssignTable = ({ refresh }) => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);

  const canShowAction = useRoleVerify("role-assign", ["can_edit", "can_delete"]);
  const { tabledata } = fields;
  const sizeOptions = [10, 20, 50, 100];

  const { data, meta, loading, error, refetch } = usePaginatedFetch(
    getRoleAccessUsersWithPagination,
    { page, limit, search: debouncedSearch }
  );

  // Refetch when parent toggles refresh
  useEffect(() => {
    refetch();
  }, [refresh, refetch]);

  const displayFields = generateDisplayFields(tabledata);
  const filteredData = FilterStatus(data);

  const { formattedData, columns } = useTableConfig({
    data: filteredData,
    page,
    limit,
    canShowAction,
    IsEdit: false,
    IsDelete: false,
    config: {
      entityName: "Role Assign",
      idKey: "id",
      deleteApi: null,
      displayFields,
    },
  });

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => { setPage(p) };

  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
        copy: true,
        csv: true,
        pdf: true,
        print: true,
        fileName: "Role Assign List",
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch: handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />  
  );
};

export default RoleAssignTable;
